import forge from 'node-forge';
import { getProcessEnvs } from './helper';
import { axiosWrapper } from './axiosClient';
import { constants } from '../constants';

export const encryptPassword = (password: string) => {
  const processEnv = getProcessEnvs();
  const certificatePem = processEnv['NEXT_PUBLIC_ENCRYPTION_KEY'];
  if (certificatePem) {
    const key = forge.pki.publicKeyFromPem(certificatePem);
    const encryptedPassword = key.encrypt(password, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha256.create(),
      },
    });
    return forge.util.encode64(encryptedPassword);
  } else {
    return password;
  }
};

export const encryptDecryptEnrolmentData = async (enrolmentData: string, isDecrypt: boolean) => {
  const processEnv = getProcessEnvs();
  const resolvedUrl = isDecrypt ? constants.ENROLMENT_DATA_DECRYPTION_URL : constants.ENROLMENT_DATA_ENCRYPTION_URL;

  try {
    const response = await axiosWrapper.post(`${processEnv['NEXT_PUBLIC_PREFIX']}${resolvedUrl}`, {
      data: [
        {
          key: 'enrolmentData',
          value: enrolmentData,
          algorithmKey: 'aesCBC',
        },
      ],
    });
    const result = response?.data?.data[0]?.value;
    return isDecrypt ? JSON.parse(result) : result;
  } catch (err) {
    console.error('Error while processing enrolmentData', err);
  }
};
